import {useCallback} from "react";

export const useYoutubeApi = () => {
  const YOUTUBE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;

  const getVideoIdFromUrl = useCallback((youtubeUrl) => {
    try {
      return youtubeUrl.includes("v=")
        ? youtubeUrl.split("v=")[1].split("&")[0]
        : youtubeUrl.split("/").pop().split("?")[0];
    } catch {
      return undefined;
    }
  }, []);

  const parseYouTubeDuration = (duration) => {
    const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);

    const hours = parseInt(match[1]) || 0;
    const minutes = parseInt(match[2]) || 0;
    const seconds = parseInt(match[3]) || 0;

    return {
      hours,
      minutes,
      seconds,
      totalSeconds: hours * 3600 + minutes * 60 + seconds,
    };
  };

  const getVideoInfo = async (videoID) => {
    if (!YOUTUBE_API_KEY) {
      console.warn(
        "REACT_APP_YOUTUBE_API_KEY is not set; skipping YouTube metadata lookup.",
      );
      return null;
    }

    const response = await fetch(
      `https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails&id=${videoID}&key=${YOUTUBE_API_KEY}`,
    );
    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    if (!data?.items?.length) {
      return null;
    }

    const videoData = data.items[0];
    const duration = parseYouTubeDuration(videoData.contentDetails.duration);
    return {
      title: videoData.snippet.title,
      duration: duration.totalSeconds,
    };
  };

  return {
    getVideoIdFromUrl,
    getVideoInfo,
  };
};
